import { render, staticRenderFns } from "./NavBarSetting.vue?vue&type=template&id=cecb3004&scoped=true&"
import script from "./NavBarSetting.vue?vue&type=script&lang=js&"
export * from "./NavBarSetting.vue?vue&type=script&lang=js&"
import style0 from "./NavBarSetting.vue?vue&type=style&index=0&id=cecb3004&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecb3004",
  null
  
)

export default component.exports